var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationpath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.699,
    height: 15.1,
    viewBox: "0 0 10.699 15.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M154.345,107.018a4.981,4.981,0,0,1,3.718-1.518,5.182,5.182,0,0,1,5.236,5.236,6.466,6.466,0,0,1-.531,2.5A17.559,17.559,0,0,1,161.4,115.9c-.531.835-1.062,1.593-1.518,2.352-.531.759-.911,1.29-1.29,1.745l-.607.607c-.152-.152-.3-.379-.607-.683-.228-.3-.683-.835-1.29-1.669s-1.138-1.593-1.593-2.352a20.44,20.44,0,0,1-1.29-2.58,7.386,7.386,0,0,1-.607-2.58A6.1,6.1,0,0,1,154.345,107.018Zm2.428,5.084a2.022,2.022,0,1,0-.531-1.366A1.829,1.829,0,0,0,156.773,112.1Z",
    transform: "translate(-152.6 -105.5)",
    fill: "#fd5634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationpath);
export default __webpack_public_path__ + "static/media/locationpath.c52be0978010eee0f068447e70863e99.svg";
export { ForwardRef as ReactComponent };